import { render, staticRenderFns } from "./CbsProductBar.vue?vue&type=template&id=7004b904&scoped=true"
import script from "./CbsProductBar.vue?vue&type=script&lang=js"
export * from "./CbsProductBar.vue?vue&type=script&lang=js"
import style0 from "./CbsProductBar.vue?vue&type=style&index=0&id=7004b904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7004b904",
  null
  
)

export default component.exports